import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

import ReactDOM from 'react-dom';
import { Collapse } from '../../Utilities/Collapse';
import { ToastBody } from '../Toast/ToastBody';
import { ToastHeader } from '../Toast/ToastHeader';

/**
 * Toast properties.
 */
export interface IToastProps extends TestingProps {
  /** This is an example comment that will show up in the docs. */
  title?: string;
  message?: string;
  variant?: string;
  bodyVariant?: string;
  progress?: number;
  isOpen?: boolean;
  timeout?: number;
  className?: string;
  onTimeout?: () => void;
  onClose?: (
    e?: React.MouseEvent<HTMLButtonElement> | undefined
  ) => void | undefined;
  rootElementId?: string;
  rootClassName?: string;
}
//get an element. if it doesn't exist create it and attach it to the dom.
const getDomElement = (id: string, element: HTMLElement) => {
  if (!!document.getElementById(id)) {
    return document.getElementById(id);
  } else {
    const tempEl = document.createElement('div');
    // tslint:disable-next-line: no-unused-expression
    tempEl && tempEl.setAttribute('id', id);
    // tslint:disable-next-line: no-unused-expression
    tempEl && element && element.appendChild(tempEl);
    return tempEl;
  }
};

/**
 * Toast
 */
export const Toast: React.FC<IToastProps> = (props) => {
  const rootEl = getDomElement(
    props.rootElementId || 'toast-root',
    document.body
  );
  props.rootClassName && rootEl.classList.add(props.rootClassName);

  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  // the reason we need this is to activate the fade out before removing the element from Dom.
  const [isShowing, setIsShowing] = React.useState<boolean>(true);

  React.useEffect(() => {
    let timer = null;
    let timer2 = null;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsOpen(true);
        if (props.timeout) {
          timer = setTimeout(() => setIsOpen(false), props.timeout);
          timer2 = setTimeout(() => {
            setIsShowing(false);
            props.onTimeout();
          }, props.timeout + 500);
        }

        //cleanup after fading out, allow 500ms for fadeout
      });
    });
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, [props.isOpen, props.timeout]);

  return isShowing
    ? ReactDOM.createPortal(
        <Collapse isOpen={isOpen} timeout={150}>
          <div>
            <div
              className={C('toast', 'fade', isOpen && 'show')}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            >
              {props.title && (
                <ToastHeader variant={props.variant} onClick={props.onClose}>
                  {props.title}
                </ToastHeader>
              )}
              <ToastBody
                onClick={!props.title && props.onClose}
                variant={props.bodyVariant}
              >
                {props.message}
                {props.progress !== null && props.progress >= 0 && (
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: props.progress + '%' }}
                      aria-valuenow={props.progress}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                )}
                {props.progress < 0 && (
                  <div className="progress">
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: '100%' }}
                      aria-valuenow={100}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                )}
              </ToastBody>
            </div>
          </div>
        </Collapse>,
        rootEl
      )
    : null;
};
